export class LemonaidRaportitUriService {
  getCustomerKuukausienStatuksetUri(asiakasAvain: string) {
    return 'customers/' + asiakasAvain + '/customer-accounting-status-per-month/' + asiakasAvain
  }
}
